import axios from 'axios'
import firebase from 'firebase'
import Cookies from 'js-cookie'

const http = axios.create({
	baseURL: 'https://' + process.env.VUE_APP_API_URL_BASE,
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded',
		'token': ''
	}
})

http.interceptors.request.use(
	(conf) => {
		conf.headers.token = Cookies.get('token')
		return conf
	}
)
  
http.interceptors.response.use(
	(res) => {
		return res
	}, 
	(err) => {
		if (err.response.status === 401) {
			firebase.auth().signOut()
		}

		return Promise.reject(err)
	}
)

export default http
